import {
	AdditiveBlending,
	CanvasTexture,
	Color,
	FrontSide,
	LinearFilter,
	MathUtils,
	Mesh,
	MeshBasicMaterial,
	PerspectiveCamera,
	PlaneGeometry,
	Raycaster,
	Scene,
	TextureLoader,
	Vector2,
	WebGLRenderer
} from 'three';

if (
	window.innerWidth >= 769 &&
	document.getElementById("cylinderCanvas") &&
	document.getElementById("cylinderCanvasInitial")
) {
	const wrapper = document.querySelector('.enterprises_wrap');
	const canvas = document.getElementById("cylinderCanvas");

	function getWrapperSize() {
		return {
			w: wrapper.clientWidth,
			h: wrapper.clientHeight
		};
	}

	// 🔥 renderer (добавили pixelRatio)
	const renderer = new WebGLRenderer({ canvas, antialias: true });
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

	let { w: windowW, h: windowH } = getWrapperSize();
	renderer.setSize(windowW, windowH);

	const scene = new Scene();
	scene.background = new Color("rgb(255, 255, 255)");

	const camera = new PerspectiveCamera(45, windowW / windowH, 1, 2000);

	function updateCameraFit(radius, cardHeight, fov = 45) {
		const fovRad = (fov * Math.PI) / 180;
		const visibleHeight = radius * 2 + cardHeight;
		const distance = (visibleHeight / 2) / Math.tan(fovRad / 2);
		return distance * 1.2;
	}

	const raycaster = new Raycaster();
	const mouse = new Vector2();

	const items = Array.from(document.querySelectorAll(".cylinder_item"));

	let cardWidth = document.querySelector('.cylinder_item').offsetWidth;
	let cardHeight = document.querySelector('.cylinder_item').offsetHeight;

	let radius = 600;
	let cards = [];

	camera.position.set(0, 0, updateCameraFit(radius, cardHeight));

	// 🔥 FIX: качественная текстура
	function makeCardTexture(
		bgUrl,
		iconUrl,
		cardWidth,
		cardHeight,
		iconWidth = 50,
		iconHeight = 50,
		iconOffset = 12,
		radius = 12,
		scale = 1.0
	) {
		return new Promise(resolve => {

			const DPR = Math.min(window.devicePixelRatio, 2);

			const canvas = document.createElement('canvas');
			canvas.width = cardWidth * DPR;
			canvas.height = cardHeight * DPR;

			const ctx = canvas.getContext('2d');
			ctx.scale(DPR, DPR);

			const bgImg = new Image();
			const iconImg = new Image();

			let loaded = 0;

			function checkLoaded() {
				loaded++;
				if (loaded === 2) {

					ctx.clearRect(0, 0, cardWidth, cardHeight);

					// скругление
					ctx.beginPath();
					ctx.moveTo(radius, 0);
					ctx.lineTo(cardWidth - radius, 0);
					ctx.quadraticCurveTo(cardWidth, 0, cardWidth, radius);
					ctx.lineTo(cardWidth, cardHeight - radius);
					ctx.quadraticCurveTo(cardWidth, cardHeight, cardWidth - radius, cardHeight);
					ctx.lineTo(radius, cardHeight);
					ctx.quadraticCurveTo(0, cardHeight, 0, cardHeight - radius);
					ctx.lineTo(0, radius);
					ctx.quadraticCurveTo(0, 0, radius, 0);
					ctx.closePath();
					ctx.clip();

					// фон
					const scaledW = cardWidth * scale;
					const scaledH = cardHeight * scale;
					const offsetX = (cardWidth - scaledW) / 2;
					const offsetY = (cardHeight - scaledH) / 2;

					ctx.drawImage(bgImg, offsetX, offsetY, scaledW, scaledH);

					// иконка
					ctx.drawImage(
						iconImg,
						cardWidth - iconWidth - iconOffset,
						cardHeight - iconHeight - iconOffset,
						iconWidth,
						iconHeight
					);

					const texture = new CanvasTexture(canvas);

					texture.minFilter = LinearFilter;
					texture.magFilter = LinearFilter;
					texture.generateMipmaps = false;
					texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
					texture.needsUpdate = true;

					resolve(texture);
				}
			}

			bgImg.src = bgUrl;
			bgImg.onload = checkLoaded;

			iconImg.src = iconUrl;
			iconImg.onload = checkLoaded;
		});
	}

	function updateCardTexture(card, scale) {
		const bg = card.userData.bg;
		const icon = card.userData.isHover
			? card.userData.iconHover
			: card.userData.iconNormal;

		makeCardTexture(bg, icon, cardWidth, cardHeight, 50, 50, 12, 12, scale)
			.then(tex => {
				card.material.map = tex;
				card.material.needsUpdate = true;
			});
	}

	async function initCards() {

		const links = items.map(el => el.getAttribute("href") || "#");

		const cardCount = items.length;
		const minCards = Math.ceil(2 * Math.PI * radius / cardWidth);
		const totalCards = Math.max(cardCount, minCards);
		const angleStep = 360 / totalCards;

		for (let i = 0; i < totalCards; i++) {

			const safeIndex = i % items.length;
			const el = items[safeIndex];

			const bgStyle = el.style.backgroundImage;
			let bg = bgStyle?.replace(/url\(["']?|["']?\)/g, "");

			if (!bg) continue;

			const textureNormal = await makeCardTexture(bg, `/img/p6.png`, cardWidth, cardHeight);

			const material = new MeshBasicMaterial({
				map: textureNormal,
				side: FrontSide,
				transparent: true,
			});

			const geometry = new PlaneGeometry(cardWidth, cardHeight);
			geometry.rotateY(Math.PI);

			const card = new Mesh(geometry, material);

			card.userData = {
				link: links[safeIndex],
				bg,
				iconNormal: `/img/p6.png`,
				iconHover: `/img/p6h.png`,
				isHover: false,
				scale: 1.0
			};

			// логотип
			const logoImg = el.querySelector('img');

			if (logoImg) {
				new TextureLoader().load(logoImg.src, (texture) => {

					texture.minFilter = LinearFilter;
					texture.magFilter = LinearFilter;
					texture.generateMipmaps = false;
					texture.anisotropy = renderer.capabilities.getMaxAnisotropy();

					const img = texture.image;

					const logoWidth = Math.min(img.width, 180);
					const logoHeight = logoWidth * (img.height / img.width);

					const logoMesh = new Mesh(
						new PlaneGeometry(logoWidth, logoHeight),
						new MeshBasicMaterial({
							map: texture,
							transparent: true,
							depthTest: false,
							depthWrite: false,
						})
					);

					logoMesh.rotation.y = Math.PI;
					card.add(logoMesh);
				});
			}

			scene.add(card);
			cards.push(card);
		}

		return { cards, angleStep };
	}

	let rotation = 0;
	let targetRotation = 0;
	let lastTime = performance.now();
	const duration = 0.5;

	async function start() {

		const { cards, angleStep } = await initCards();

		function updateCards(rot) {
			const offset = -angleStep;

			cards.forEach((card, i) => {
				const angle = MathUtils.degToRad(i * angleStep + rot + offset);

				card.position.set(
					Math.sin(angle) * radius,
					0,
					Math.cos(angle) * radius
				);

				card.lookAt(0, 0, 0);
			});
		}

		// hover
		let hoveredCard = null;

		canvas.addEventListener("mousemove", (event) => {
			const rect = canvas.getBoundingClientRect();

			mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
			mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

			raycaster.setFromCamera(mouse, camera);

			const intersects = raycaster.intersectObjects(cards, true);

			cards.forEach(c => c.userData.isHover = false);

			if (intersects.length > 0) {
				let hovered = intersects[0].object;
				while (!hovered.userData.link && hovered.parent) {
					hovered = hovered.parent;
				}
				hovered.userData.isHover = true;
				hoveredCard = hovered;
			} else {
				hoveredCard = null;
			}

			canvas.style.cursor = hoveredCard ? 'pointer' : 'default';
		});

		// click
		canvas.addEventListener("click", (event) => {
			const rect = canvas.getBoundingClientRect();

			mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
			mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

			raycaster.setFromCamera(mouse, camera);

			const intersects = raycaster.intersectObjects(cards);

			if (intersects.length > 0) {
				const clickedCard = intersects[0].object;
				if (clickedCard.userData.link) {
					window.open(clickedCard.userData.link, "_blank");
				}
			}
		});

		// 🔥 autoRotate ОСТАВЛЕН
		let autoRotate = true;
		let intervalId = null;

		function startAutoRotate() {
			if (intervalId) return;

			intervalId = setInterval(() => {
				if (autoRotate) targetRotation -= angleStep;
			}, 3500);
		}

		startAutoRotate();

		function animate() {
			requestAnimationFrame(animate);

			const now = performance.now();
			const delta = (now - lastTime) / 1000;
			lastTime = now;

			const diff = targetRotation - rotation;
			rotation += diff * Math.min(delta / duration, 1);

			updateCards(rotation);

			// hover scale
			cards.forEach(card => {
				const targetScale = card.userData.isHover ? 1.1 : 1.0;

				card.userData.scale = MathUtils.lerp(
					card.userData.scale,
					targetScale,
					0.08
				);

				if (Math.abs(card.userData.scale - targetScale) > 0.001) {
					updateCardTexture(card, card.userData.scale);
				}
			});

			renderer.render(scene, camera);
		}

		animate();
	}

	start();

	// resize
	function resizeRenderer() {
		const w = wrapper.clientWidth;
		const h = wrapper.clientHeight;

		renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
		renderer.setSize(w, h);

		camera.aspect = w / h;
		camera.updateProjectionMatrix();
	}

	resizeRenderer();
	window.addEventListener('resize', resizeRenderer);
}